import { render, staticRenderFns } from "./compoundProductList.vue?vue&type=template&id=314470a4&scoped=true&"
import script from "./compoundProductList.vue?vue&type=script&lang=js&"
export * from "./compoundProductList.vue?vue&type=script&lang=js&"
import style0 from "./compoundProductList.vue?vue&type=style&index=0&id=314470a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "314470a4",
  null
  
)

export default component.exports